"use client";
import { CheckIcon } from "lucide-react";
import { SignupCtaButton } from "../signup-cta-button";

export function Pricing() {
  return (
    <section id="pricing" className="py-12 md:py-20 relative z-10">
      <div className="container mx-auto px-4 max-w-4xl text-center">
        
        <h2 className="text-5xl md:text-7xl font-black text-white tracking-tighter mb-6">
          Simples. <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-purple-500">Justo.</span>
        </h2>
        <p className="text-xl text-white/50 mb-12 max-w-xl mx-auto">
          Comece agora. Sem burocracia, sem surpresas no cartão. O primeiro mês é por nossa conta.
        </p>

        <div className="relative group mx-auto max-w-xl text-left">
          <div className="absolute -inset-1 bg-gradient-to-r from-primary/30 to-purple-500/30 rounded-3xl blur-xl opacity-50 group-hover:opacity-100 transition duration-1000"></div>
          
          <div className="relative bg-[#0a0a0a]/90 backdrop-blur-2xl border border-white/10 rounded-3xl p-8 md:p-12 overflow-hidden">
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 blur-[100px] rounded-full pointer-events-none translate-x-1/2 -translate-y-1/2" />
            
            <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-8 mb-10">
               <div>
                 <h3 className="text-2xl font-bold text-white mb-2">Plano Pro</h3>
                 <p className="text-white/60 text-sm">Tudo o que você precisa para decolar.</p>
               </div>
               <div className="text-left md:text-right">
                 <div className="flex items-baseline gap-1">
                   <span className="text-2xl font-bold text-white/50">R$</span>
                   <span className="text-6xl font-black text-white tracking-tighter">19,99</span>
                   <span className="text-white/50">/mês</span>
                 </div>
               </div>
            </div>

            <div className="h-px w-full bg-gradient-to-r from-transparent via-white/10 to-transparent mb-10" />

            <div className="grid sm:grid-cols-2 gap-y-4 gap-x-8 mb-10">
               {[
                 "Agendamentos ilimitados",
                 "Site personalizado (Subdomínio)",
                 "Painel de Gestão Completo",
                 "Lembretes e Confirmações",
                 "Suporte Dedicado",
                 "Tecnologia PWA (App)",
               ].map((feature, i) => (
                 <div key={i} className="flex items-center gap-3">
                    <div className="size-5 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                      <CheckIcon className="size-3 text-primary" />
                    </div>
                    <span className="text-white/80 text-sm font-medium">{feature}</span>
                 </div>
               ))}
            </div>

            <div className="w-full">
              <SignupCtaButton className="w-full bg-white text-black hover:bg-white/90 shadow-[0_0_30px_rgba(255,255,255,0.2)] rounded-2xl h-14 md:h-16 text-base md:text-lg" />
              <p className="text-center text-xs text-white/40 mt-4">
                30 dias grátis. Pagamento manual sem compromisso.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
